import types from '../mutation-types';
import CrmConfigAPI from '../../api/crmConfig';

export const state = {
  record: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getCrmConfig(_state) {
    return _state.record;
  },
};

export const actions = {
  get: async function getCrmConfig({ commit }) {
    commit(types.SET_CRM_CONFIG_UI_FLAG, { isFetching: true });
    try {
      const response = await CrmConfigAPI.show();
      commit(types.SET_CRM_CONFIG, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CRM_CONFIG_UI_FLAG, { isFetching: false });
    }
  },
  update: async ({ commit }, data) => {
    commit(types.SET_CRM_CONFIG_UI_FLAG, { isUpdating: true });
    try {
      const response = await CrmConfigAPI.update(data);
      commit(types.SET_CRM_CONFIG, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CRM_CONFIG_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_CRM_CONFIG_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CRM_CONFIG](_state, data) {
    _state.record = data;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
